'use client';

import { HStack, VStack } from '@terra/ui-styled-system';
import {
  LabelDefault,
  MetaDefault,
  MonoSmall,
} from '../../../../../components/typography';

export type AssetMergeHitlParty = {
  assetId: string;
  method?: string;
  url?: string;
  path?: string;
  domain?: string;
};

export type AssetMergeHitlSection = {
  title: string;
  parties: AssetMergeHitlParty[];
};

const EMPTY_HITL_SECTION_LABEL = 'None';

const longTextWrapProps = {
  display: 'block',
  w: 'full',
  minW: 0,
  overflowWrap: 'anywhere',
  wordBreak: 'break-all',
  whiteSpace: 'normal',
} as const;

const AssetMergeHitlPartyRow = ({ party }: { party: AssetMergeHitlParty }) => {
  const route = party.url ?? party.path;
  const meta = [party.assetId, party.domain].filter(Boolean).join(' · ');
  const method = party.method?.toUpperCase();
  const primary = route ?? party.assetId;

  return (
    <HStack alignItems="flex-start" gap={1.5} w="full" minW={0}>
      {method ? (
        <MonoSmall color="fg.muted" flexShrink={0}>
          {method}
        </MonoSmall>
      ) : null}
      <VStack gap={0} alignItems="stretch" minW={0} flex={1}>
        <MonoSmall color="fg.default" {...longTextWrapProps}>
          {primary}
        </MonoSmall>
        {route && meta ? (
          <MetaDefault color="fg.muted" {...longTextWrapProps}>
            {meta}
          </MetaDefault>
        ) : null}
      </VStack>
    </HStack>
  );
};

export const AssetMergeHitlSections = ({
  sections,
}: {
  sections: AssetMergeHitlSection[];
}) => (
  <VStack gap={2} alignItems="stretch" w="full" minW={0}>
    {sections.map((section) => (
      <VStack
        key={section.title}
        gap={1}
        alignItems="stretch"
        w="full"
        minW={0}
      >
        <LabelDefault color="fg.muted">{section.title}</LabelDefault>
        {section.parties.length === 0 ? (
          <MetaDefault color="fg.muted">{EMPTY_HITL_SECTION_LABEL}</MetaDefault>
        ) : (
          section.parties.map((party) => (
            <AssetMergeHitlPartyRow key={party.assetId} party={party} />
          ))
        )}
      </VStack>
    ))}
  </VStack>
);
